import React, { useEffect, useState } from "react";

import ClassTalkMassages from "../classtalk/ClassTalkMessages";
import EmoticItem from "../classtalk/emoticon/EmoticItem";
import EmoticList from "../classtalk/emoticon/EmoticList";
import AudioRecord from "../classtalk/voiceMemo/AudioRecord";
import InputGroupBox from "../classtalk/InputGroupBox";
import FunctionList from "../classtalk/FunctionList";

const ClassTalk = ({ openInfo, classTalkMsg, progressCount, isProgressBarShow, whisperMemberSeq, handleSelectedClassTalkFunc }) => {
    const [progress, setProgress] = useState(0);
    const [isShow, setIsShow] = useState(isProgressBarShow);

    useEffect(() => {
        setProgress(progressCount);
    }, [progressCount]);

    useEffect(() => {
        setIsShow(isProgressBarShow);
    }, [isProgressBarShow]);

    return (
        <div className="d-flex flex-column pbl-chat-screen" style={{ minHeight: '50%', height: '100%' }}>
            <div className="progress-container" style={{ display: isShow ? "flex" : "none" }}>
                <div id="whisper-browser-progressbar" className="progress-fill" style={{ width: `${progress}%` }}>
                    {progress} %
                </div>
            </div>
            <ClassTalkMassages
                classTalkMsg={classTalkMsg}
                handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
            />
            {
                openInfo.selectedEmoticonSeq > -1 &&
                <EmoticItem
                    selIndex={openInfo.selectedEmoticonSeq}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
            {
                openInfo.isEmoticonSelected &&
                <EmoticList handleSelectedClassTalkFunc={handleSelectedClassTalkFunc} />
            }
            {
                openInfo.isAudioOpened ?
                    <AudioRecord
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    /> :
                    <InputGroupBox
                        selIndex={openInfo.selectedEmoticonSeq}
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    />
            }
            {
                openInfo.isAddFunctionOpened &&
                <FunctionList
                    isWhisper={true}
                    isChatting={true}
                    whisperMemberSeq={whisperMemberSeq}
                    isActiveLive={false}
                    isPanelWindowOpened={false}
                    onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
        </div>
    );
}

export default ClassTalk;
